var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDraw = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c4a000",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: -20,
    y: 13
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fcffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15 14v2.0625c-.537663.111041-1.024662.383291-1.375.78125l-1.78125-1.03125-.5.875 1.78125 1.03125c-.082063.247432-.125.506395-.125.78125s.04294.533818.125.78125l-1.78125 1.03125.5.875 1.78125-1.03125c.352503.40042.832682.670182 1.375.78125v2.0625h1v-2.0625c.537663-.111041 1.024662-.383291 1.375-.78125l1.78125 1.03125.5-.875-1.78125-1.03125c.082063-.247432.125-.506395.125-.78125s-.04294-.533818-.125-.78125l1.78125-1.03125-.5-.875-1.78125 1.03125c-.352503-.40042-.832682-.670182-1.375-.78125v-2.0625zm.5 3.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 19 9-.0096s0 0 0-2c0-2.9904-1-2.9904-4.5-2.9904s-4.5 0-4.5 3z",
    fillRule: "evenodd",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m8.0275933 9.5013891c-2.8183472.0466368-5.2878242 1.2552559-6.2839838 4.1947259-.98846785 2.916771 1.1714865 8.182008 5.9325763 5.840503 7.9077412-3.889027 7.9038032.963382 9.8807382.963382 2.438571 0 4.94037-1.699566 4.94037-3.873599 0-1.944514.09638-3.806388-.992208-4.87712-1.976935-1.944514-2.973677.987396-8.289071-1.184158-1.694017-.6920746-3.4974127-1.0917169-5.1884217-1.0637339z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#555753",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDraw, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/draw.860cb4fc.svg";
export { ForwardRef as ReactComponent };